// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3R0LY","notes":"Notes_notes__rt9P1"};